var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConectionsGrayIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.90039C6.88071 8.90039 8 7.7811 8 6.40039C8 5.01968 6.88071 3.90039 5.5 3.90039C4.11929 3.90039 3 5.01968 3 6.40039C3 7.7811 4.11929 8.90039 5.5 8.90039ZM5.5 8.90039V16.9004M5.5 16.9004C4.11929 16.9004 3 18.0197 3 19.4004C3 20.7811 4.11929 21.9004 5.5 21.9004C6.88071 21.9004 8 20.7811 8 19.4004C8 18.0197 6.88071 16.9004 5.5 16.9004ZM18.5 16.9004V9.60039C18.5 8.48029 18.5 7.92023 18.282 7.49241C18.0903 7.11608 17.7843 6.81012 17.408 6.61838C16.9802 6.40039 16.4201 6.40039 15.3 6.40039H12M18.5 16.9004C19.8807 16.9004 21 18.0197 21 19.4004C21 20.7811 19.8807 21.9004 18.5 21.9004C17.1193 21.9004 16 20.7811 16 19.4004C16 18.0197 17.1193 16.9004 18.5 16.9004ZM12 6.40039L14.5 8.90039M12 6.40039L14.5 3.90039",
    stroke: "#B4B1B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConectionsGrayIcon);
export default __webpack_public_path__ + "static/media/ConectionsGrayIcon.f83d198a0f00e43b4156b57e63f66cee.svg";
export { ForwardRef as ReactComponent };